import React from 'react';
import { Link } from 'react-router-dom';
import truncate from 'lodash/truncate';

const GridArticles = ({ rows }) => (
  <div className="row assignments-grid mt-n3">
    {rows.map((r) => {
      const href = `/articles/${r._id}`;

      return (
        <div
          key={r._id}
          className="col-12 col-lg-6 col-xl-4 mt-3"
        >
          <div className="ratio-standard position-relative bg-light">
            {r.coverImg && (
              <Link
                to={href}
              >
                <div
                  className="img-bg-cover"
                  style={{ backgroundImage: `url(${r.coverImg})` }}
                ></div>
              </Link>
            )}
          </div>
          <div className="p-3">
            <Link
              to={href}
            >
              <h4>{r.title}</h4>
            </Link>
            <p className="py-3">
              {truncate(r.contentText, {
                length: 60,
                omission: '……',
              })}
            </p>
            <div className="text-right">
              <Link
                to={href}
                className="btn btn-primary px-4 py-2"
              >
                <span className="mr-3">
                  閱讀文章
                </span>
                &nbsp;
                <img
                  src='assets/img/long-arrow-right.svg'
                  style={{ width: '38px', height: '9px' }}
                />
              </Link>
            </div>
          </div>
        </div>
      );
    })}
  </div>
);

export default GridArticles;
